
import moment from 'moment-timezone';

export const dateFormatForUser = (dateString) => {
    // const utcTime = moment.utc(dateString);
    // console.log("utcTime",utcTime);
    // const indianTime = utcTime.tz('Asia/Kolkata');
  
    const indianTime = moment.utc(dateString).tz("Asia/Kolkata");
    const day1 = indianTime.format('DD');
    const month1 = indianTime.format('MMMM');
    const year1 = indianTime.format('YYYY');
    const hours1 = indianTime.format('hh');
    const minutes1 = indianTime.format('mm');
    const period1 = indianTime.format('A');
  
    console.log("UTC Time:", dateString);
    console.log("Indian Time:", indianTime.format("YYYY-MM-DD hh:mm A"));
  
    // console.log("day1",day1);
    // console.log("month1",month1);
    // console.log("year1",year1);
    // console.log("hours1",hours1);
    // console.log("minutes1",minutes1);
    // console.log("period1",period1);
    //${hours1}:${minutes1} ${period1}
    return `${month1} ${day1}, ${year1}`;

  };

  export const timeFormatForUser = (dateString) => {
    // const utcTime = moment.utc(dateString);
    // console.log("utcTime",utcTime);
    // const indianTime = utcTime.tz('Asia/Kolkata');
  
    const indianTime = moment.utc(dateString).tz("Asia/Kolkata");
    const day1 = indianTime.format('DD');
    const month1 = indianTime.format('MMMM');
    const year1 = indianTime.format('YYYY');
    const hours1 = indianTime.format('hh');
    const minutes1 = indianTime.format('mm');
    const period1 = indianTime.format('A');
  
    console.log("UTC Time:", dateString);
    console.log("Indian Time:", indianTime.format("YYYY-MM-DD hh:mm A"));
  
    // console.log("day1",day1);
    // console.log("month1",month1);
    // console.log("year1",year1);
    // console.log("hours1",hours1);
    // console.log("minutes1",minutes1);
    // console.log("period1",period1);
    //${hours1}:${minutes1} ${period1}
    return `${hours1}:${minutes1} ${period1}`;

  };
  export function capitalizeFirstLetter(inputString) {
    // if (typeof inputString !== "string" || inputString.length === 0) {
    //   return inputString;
    // }
  
    // return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  
    if (typeof inputString !== "string" || inputString.length === 0) {
      return inputString;
    }
  
    const words = inputString.split(' ');
  
    const capitalizedWords = words.map((word) => {
      if (word.length > 0) {
        return word[0].toUpperCase() + word.substring(1);
      }
    }).join(" ");
  
    //   words.map((word) => { 
    //     return word[0].toUpperCase() + word.substring(1); 
    // }).join(" ");
  
    return capitalizedWords;
  }


  